import postAPI from './postAPI.js'

export default async function postReopenTaskInstance(body) {
    const data = await postAPI('admin/taskinstances/reopen', body);
    return data;
}
